import type { RoadmapItemStatus } from "@/services/api/types";
import styled from "styled-components";
import { getRoadmapStatusBg, getRoadmapStatusDot } from "../statusColors";

export const ModalContent = styled.div`
  padding: 0.75rem 0.75rem 0.5rem;
  text-align: left;

  pre {
    font-family: inherit;
    line-height: 1.5rem;
    font-size: 1rem;
    font-weight: 300;
    white-space: pre-wrap;
  }
  button {
    padding-top: 0;
  }
`;

export const StatusTooltip = styled.span<{ $position?: "top" | "right" }>`
  visibility: hidden;
  position: absolute;
  background: ${(props) => props.theme.gradients.dark1};
  color: ${(props) => props.theme.colors.lightest};
  text-align: left;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  z-index: 3;
  white-space: normal;
  width: max-content;
  max-width: 300px;
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 1.3rem;
  opacity: 0;
  transition: opacity 0.3s;

  ${(props) =>
    props.$position === "right"
      ? `
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin-left: 0.5rem;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 100%;
      margin-top: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent ${props.theme.colors.darkest} transparent transparent;
    }
  `
      : `
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);

    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: ${props.theme.colors.darkest} transparent transparent transparent;
    }
  `}
`;

export const ModalStatus = styled.strong<{ $status?: RoadmapItemStatus }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 10px;
  font-weight: 300;
  position: relative;
  ${(props) =>
    props.$status &&
    `
    background: ${getRoadmapStatusBg(props.$status)};
  `};

  ${(props) => props.theme.media.medium} {
    cursor: help;

    &:hover span {
      visibility: visible;
      opacity: 1;
    }
  }

  &::before {
    display: inline-block;
    content: "";
    height: 10px;
    width: 10px;
    border-radius: 5px;
    background: grey;
    margin-right: 0.5rem;
    ${(props) =>
      props.$status &&
      `
    background: ${getRoadmapStatusDot(props.theme, props.$status)};
  `};
  }
`;

export const WhatsChanged = styled.div`
  background: ${(props) => props.theme.gradients.light2};
  border-radius: 8px;
  margin-top: 1.5rem;
  padding: 1.5rem 1.5rem 0.75em;

  h4 {
    margin: 0;
  }

  pre {
    margin: 0.25rem 0;
  }
`;
